export const USER_OPTIONS = [
  "id",
  "fullname",
  "login",
  "position",
  "email",
  "phone",
  "role",
  "status",
  "Dealer",
  "countDC",
  "lastOnlineDate",
  "isAnnouncementsAccess",
  "isAnnouncementsSend",
];

export const CERTIFICATION_OPTIONS_TABLE = [
  "code",
  "codeIS",
  "certificateValidityPeriod",
  "name",
  "levelName",
  "completedDate",
  "certificateExpirationDate",
];

export const CERTIFICATION_OPTIONS_ITEMS = [
  {
    id: 1,
    code: "МС-СТ",
    codeIS: "4420",
    сertificationPeriod: "27",
    name: "МС-СТ Сертификация специалистов по маркетингу",
    typeCourse: "Базовый уровень",
    dateOfPassage: "2024-09-03 15:41:21",
    dateOfTheNextCertification: "",
  },
  {
    id: 2,
    code: "МС-СТ",
    codeIS: "4456",
    сertificationPeriod: "Бессрочно",
    name: "МС-СТ Сертификация специалистов по маркетингу",
    typeCourse: "Стандартный уровень",
    dateOfPassage: "2024-09-03 15:41:21",
    dateOfTheNextCertification: "",
  },
  {
    id: 3,
    code: "МС-СТ",
    codeIS: "8903",
    сertificationPeriod: "12",
    name: "МС-СТ Сертификация специалистов по маркетингу",
    typeCourse: "Сертификаия",
    dateOfPassage: "2024-09-03 15:41:21",
    dateOfTheNextCertification: "2024-09-03 15:42:34",
  },
];
